// extracted by mini-css-extract-plugin
export default {"cls1":"PlVsnTJu3tnMwc5hRftG","cls2":"_1ULmlrMbZZvZsg0ivYRW PlVsnTJu3tnMwc5hRftG"};